export const combinationRules = {
  "combinationRules.rules.get": "combinationRules.rules.get",
  "combinationRules.rules.create": "combinationRules.rules.create",
  "combinationRules.rules.edit": "combinationRules.rules.edit",
  "combinationRules.rules.checkAll": "combinationRules.rules.checkAll",
  "combinationRules.rules.report": "combinationRules.rules.report",
} as const;
